export default __webpack_public_path__ + "static/media/one-last-step.f085b1d6.svg";